import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';

const HomePage = React.memo(() => {
  return (
    <>
      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 font-poppins'>
        <div className='grid grid-rows-reg min-h-screen xl:min-h-0'>
          {/* Navigation */}
          <Navbar />
          <HomePageHeader />
        </div>

        {/* Main page content */}
        <HomePageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
});

export default HomePage;
